<template>
  <fwb-navbar class="bg-black relative flex justify-between items-center w-full">
    <!-- Logo - visible en móvil y desktop -->
    <template #logo>
      <fwb-navbar-logo
        alt="Tuin gabi"
        :image-url="logoTuin"
        link="#"
        class="sm:max-w-[120px] sm:max-h-[120px] max-w-[80px] max-h-[80px]"
      />
    </template>

    <template #default="{ isShowMenu }">
      <!-- Contenedor del menú móvil -->
      <div class="sm:hidden flex items-center w-full justify-between">
        <!-- Botón hamburguesa solo para móviles -->
        <fwb-navbar-toggle 
          :is-show-menu="isShowMenu"
          class="text-white hover:bg-black focus:bg-black ml-auto"
        />
        <!-- Overlay -->
        <div 
          class="navbar-overlay"
          :class="{'show': isShowMenu}"
          @click="$event.target.classList.contains('navbar-overlay') && $emit('update:isShowMenu', false)"
        ></div>

        <!-- Menú desplegable para móviles -->
        <fwb-navbar-collapse 
          :is-show-menu="isShowMenu"
          class="fixed top-[80px] left-0 right-0 z-50"
        >
          <div class="flex flex-col w-full py-2 space-y-2 bg-black border border-gray-700 rounded-md shadow-lg text-center max-h-[80vh] overflow-y-auto">
            <!-- Opciones del menú móvil -->
            <a href="/dashboard" class="px-4 py-2 text-white hover:bg-[#FF4265]">
              Dashboard
            </a>
            <a href="/users" class="px-4 py-2 text-white hover:bg-[#FF4265]">
              Usuarios
            </a>
            <a href="/advisors" class="px-4 py-2 text-white hover:bg-[#FF4265]">
              Asesores
            </a>
            <!-- Catálogos -->
            <div class="px-4 py-2 text-white">
              <button @click="toggleSubmenu('catalogs')" class="w-full flex justify-center items-center">
                <span>Catálogos</span>
                <svg 
                  class="w-4 h-4 ml-2 transition-transform"
                  :class="{'rotate-180': activeSubmenu === 'catalogs'}"
                  fill="none"
                  stroke="currentColor"
                  viewBox="0 0 24 24"
                >
                  <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M19 9l-7 7-7-7"/>
                </svg>
              </button>
              <div v-show="activeSubmenu === 'catalogs'" class="pl-4 mt-2 space-y-1">
                <a href="/catalogs/roles" class="block px-2 py-1 text-white hover:bg-[#FF4265]">
                  Roles
                </a>
                <a href="/catalogs/cargos" class="block px-2 py-1 text-white hover:bg-[#FF4265]">
                  Cargos
                </a>
                <a href="/catalogs/cuentas" class="block px-2 py-1 text-white hover:bg-[#FF4265]">
                  Cuentas
                </a>
                <a href="/catalogs/planes" class="block px-2 py-1 text-white hover:bg-[#FF4265]">
                  Planes
                </a>
                <a href="/catalogs/countries" class="block px-2 py-1 text-white hover:bg-[#FF4265]">
                  Códigos telefónicos
                </a>
              </div>
            </div>
            <!-- Catálogos -->
            <a href="/Propiedades" class="px-4 py-2 text-white hover:bg-[#FF4265]">
              Propiedades
            </a>
            <a href="/prospecto/prospectos-list" class="px-4 py-2 text-white hover:bg-[#FF4265]">
              Prospectos
            </a>
            <a href="/company/company-list" class="px-4 py-2 text-white hover:bg-[#FF4265]">
              Compañías
            </a>
            <!-- Blog -->
            <div class="px-4 py-2 text-white">
              <button @click="toggleSubmenu('blog')" class="w-full flex justify-center items-center">
                <span>Blog</span>
                <svg 
                  class="w-4 h-4 ml-2 transition-transform"
                  :class="{'rotate-180': activeSubmenu === 'blog'}"
                  fill="none"
                  stroke="currentColor"
                  viewBox="0 0 24 24"
                >
                  <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M19 9l-7 7-7-7"/>
                </svg>
              </button>
              <div 
                v-show="activeSubmenu === 'blog'"
                class="pl-4 mt-2 space-y-1"
              >
                <a href="/blog/post" class="block px-2 py-1 text-white hover:bg-[#FF4265]">
                  Post
                </a>
                <a href="/blog/categorias" class="block px-2 py-1 text-white hover:bg-[#FF4265]">
                  Categorías
                </a>
              </div>
            </div>
            <!-- Blog -->
            <a href="/legal" class="px-4 py-2 text-white hover:bg-[#FF4265]">
              Legal
            </a>
            <!-- Reportes -->
            <div class="px-4 py-2 text-white">
              <button @click="toggleSubmenu('report')" class="w-full flex justify-center items-center">
                <span>Reportes</span>
                <svg 
                  class="w-4 h-4 ml-2 transition-transform"
                  :class="{'rotate-180': activeSubmenu === 'report'}"
                  fill="none"
                  stroke="currentColor"
                  viewBox="0 0 24 24"
                >
                  <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M19 9l-7 7-7-7"/>
                </svg>
              </button>
              <div 
                v-show="activeSubmenu === 'report'"
                class="pl-4 mt-2 space-y-1"
              >
                <a href="/reports/list" class="block px-2 py-1 text-white hover:bg-[#FF4265]">
                  Lista
                </a>
                <a href="/reports/reasons" class="block px-2 py-1 text-white hover:bg-[#FF4265]">
                  Motivos
                </a>
              </div>
            </div>
            <!-- Reportes -->
            <!-- Configuración -->
            <div class="px-4 py-2 text-white">
              <button @click="toggleSubmenu('config')" class="w-full flex justify-center items-center">
                <span>Configuración</span>
                <svg 
                  class="w-4 h-4 ml-2 transition-transform"
                  :class="{'rotate-180': activeSubmenu === 'config'}"
                  fill="none"
                  stroke="currentColor"
                  viewBox="0 0 24 24"
                >
                  <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M19 9l-7 7-7-7"/>
                </svg>
              </button>
              <div 
                v-show="activeSubmenu === 'config'"
                class="pl-4 mt-2 space-y-1"
              >
                <a href="/info-profile" class="block px-2 py-1 text-white hover:bg-[#FF4265]">
                  Perfil
                </a>
                <a href="/info-company" class="block px-2 py-1 text-white hover:bg-[#FF4265]">
                  Compañía
                </a>
                <a href="/info-password" class="block px-2 py-1 text-white hover:bg-[#FF4265]">
                  Contraseña
                </a>
                <a href="/info-networks" class="block px-2 py-1 text-white hover:bg-[#FF4265]">
                  Redes sociales
                </a>
              </div>
            </div>
             <!-- Configuración -->
            <button @click="outsession" class="w-full text-left px-4 py-2 text-[#FF4265] hover:bg-gray-800 text-center">
              Cerrar sesión
            </button>
          </div>
        </fwb-navbar-collapse>
      </div>

      <!-- Menú para desktop (oculto en móviles) -->
      <div class="hidden sm:block relative ml-auto">
        <button @click="toggleDropdown" class="flex items-center px-4 py-2 text-white hover:text-gray-300 focus:outline-none">
          <div class="flex flex-col justify-start items-start">
            <span class="text-sm">{{ userSession?.name || 'Opciones' }}</span>
            <div class="text-xs text-gray-400 mt-1">admin</div>
          </div>

          <svg 
            class="w-4 h-4 ml-2"
            :class="{'rotate-180': isOpen}"
            fill="none"
            stroke="currentColor"
            viewBox="0 0 24 24"
          >
            <path 
              stroke-linecap="round"
              stroke-linejoin="round"
              stroke-width="2"
              d="M19 9l-7 7-7-7"
            />
          </svg>
        </button>

        <!-- Menú desplegable para desktop -->
        <div v-show="isOpen" class="absolute right-0 mt-2 w-48 py-2 bg-white rounded-md shadow-xl z-50">
          <a href="/info-profile" class="block px-4 py-2 text-sm text-gray-700 hover:bg-gray-100">
            Perfil
          </a>
          <a href="/configuracion" class="block px-4 py-2 text-sm text-gray-700 hover:bg-gray-100">
            Configuración
          </a>
          <button @click="outsession" class="w-full text-left px-4 py-2 text-sm text-gray-700 hover:bg-gray-100">
            Cerrar sesión
          </button>
        </div>
      </div>
    </template>
  </fwb-navbar>
</template>


<script setup>
import {
  FwbNavbar,
  FwbNavbarCollapse,
  FwbNavbarLogo,
  FwbNavbarToggle,
} from "flowbite-vue";
import { computed, ref, onMounted, onBeforeUnmount } from "vue";
import { useStore } from "vuex";
import logoTuin from '@/assets/imgs/GABI.svg';

const store = useStore();
const userSession = computed(() => store.getters.getUserSession);
const isOpen = ref(false);
const activeSubmenu = ref(null);

function toggleSubmenu(menu) {
  if (activeSubmenu.value === menu) {
    activeSubmenu.value = null;
  } else {
    activeSubmenu.value = menu;
  }
}

function toggleDropdown() {
  isOpen.value = !isOpen.value;
}

function closeDropdown(event) {
  const dropdownContainer = document.querySelector('.relative');
  if (dropdownContainer && !dropdownContainer.contains(event.target)) {
    isOpen.value = false;
  }
}

async function outsession() {
  await store.dispatch("clearUserSession");
  window.location.replace("/login");
}

onMounted(() => {
  document.addEventListener('click', closeDropdown);
});

onBeforeUnmount(() => {
  document.removeEventListener('click', closeDropdown);
});
</script>

<style scoped>
/* Estilos para el menú móvil */
@media (max-width: 768px) {
  fwb-navbar-collapse {
    position: fixed;
    top: 80px; /* Ajusta según la altura de tu navbar */
    left: 0;
    right: 0;
    width: 100%;
    max-height: 0;
    overflow: hidden;
    transition: all 0.3s ease-in-out;
    background-color: #000;
    z-index: 50;
    box-shadow: 0 4px 6px rgba(0, 0, 0, 0);
  }

  .fwb-navbar-collapse.show {
    max-height: calc(100vh - 80px);
    overflow-y: auto;
  }

  .fwb-navbar-collapse > div {
    padding: 1rem 0;
    background-color: #000;
  }

  /* Estilo para el overlay opcional */
  .navbar-overlay {
    position: fixed;
    top: 80px;
    left: 0;
    right: 0;
    bottom: 0;
    background-color: rgba(0, 0, 0, 0);
    z-index: 40;
    opacity: 0;
    pointer-events: none;
    transition: opacity 0.3s ease;
  }

  .navbar-overlay.show {
    opacity: 1;
    pointer-events: auto;
  }
}
</style>